import type { ReportingSubmission } from '../services/dashboardData';
import { departmentIdScopeKey } from '../utils/normalizeIds';

const selectedDepartmentKeySet = (departmentIds: string[]): Set<string> =>
  new Set(departmentIds.map((id) => departmentIdScopeKey(id)).filter(Boolean));

export function reportingSubmissionMatchesClientDepartmentFilter(
  submission: ReportingSubmission,
  departmentKeys: Set<string>,
): boolean {
  if (!departmentKeys.size) return true;

  const primary = departmentIdScopeKey(submission.departmentId ?? submission.departmentName ?? '');
  const isCrossAudit = submission.isCrossAudit || submission.crossAudit;
  if (!isCrossAudit) return Boolean(primary && departmentKeys.has(primary));

  const audited = departmentIdScopeKey(submission.auditedDepartmentId ?? '');
  const auditor = departmentIdScopeKey(
    (submission as ReportingSubmission & { auditorDepartmentId?: string }).auditorDepartmentId ?? '',
  );

  return Boolean(
    (primary && departmentKeys.has(primary)) ||
      (audited && departmentKeys.has(audited)) ||
      (auditor && departmentKeys.has(auditor)),
  );
}

export function filterReportingSubmissionsByClientDepartments(
  submissions: ReportingSubmission[],
  departmentIds: string[] | null | undefined,
): ReportingSubmission[] {
  if (!departmentIds?.length) return submissions;
  const departmentKeys = selectedDepartmentKeySet(departmentIds);
  if (!departmentKeys.size) return submissions;
  return submissions.filter((submission) =>
    reportingSubmissionMatchesClientDepartmentFilter(submission, departmentKeys),
  );
}
